import { Ability } from '@casl/ability';
import { initialAbility } from './config'
import store from "@/store/index";

const existingAbility = store.state.authentication.user.roles ? store.state.authentication.user.roles : null

export default new Ability(existingAbility || initialAbility)
